import { render } from "./GuestMain.vue?vue&type=template&id=3d136710"
import script from "./GuestMain.vue?vue&type=script&lang=js"
export * from "./GuestMain.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__